// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* qchat_fe/src/Component/SideData/Overview/AiAgentWorkFlow/ConnectorDefinitionsPanel.module.css
 *
 * Styles for the connector definitions library panel. Mirrors the
 * visual language of OAuthConnections.module.css so the two tabs of
 * the Connectors page look coherent. */

.ConnectorDefinitionsPanel_container__CQRO7 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ConnectorDefinitionsPanel_loadingBlock__VoRZE {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #718096;
  font-size: 14px;
  padding: 32px 0;
  justify-content: center;
}

.ConnectorDefinitionsPanel_spin__d7QQD {
  animation: ConnectorDefinitionsPanel_spin__d7QQD 1s linear infinite;
}

@keyframes ConnectorDefinitionsPanel_spin__d7QQD {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

.ConnectorDefinitionsPanel_headerRow__t7IiV {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.ConnectorDefinitionsPanel_title__9dEev {
  font-size: 20px;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 6px 0;
}

.ConnectorDefinitionsPanel_subtitle__DXjVC {
  font-size: 13px;
  color: #718096;
  line-height: 1.55;
  margin: 0;
  max-width: 680px;
}

.ConnectorDefinitionsPanel_createBtn__00mTB {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  background: #4299e1;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;
}

.ConnectorDefinitionsPanel_createBtn__00mTB:hover {
  background: #3182ce;
}

.ConnectorDefinitionsPanel_emptyState__kNm0j {
  padding: 48px 24px;
  text-align: center;
  border: 1px dashed #cbd5e0;
  border-radius: 8px;
  color: #718096;
  font-size: 14px;
  background: #f7fafc;
}

.ConnectorDefinitionsPanel_emptyState__kNm0j p {
  margin: 0;
}

.ConnectorDefinitionsPanel_list__-4H7d {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ConnectorDefinitionsPanel_card__nWERK {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.ConnectorDefinitionsPanel_card__nWERK:hover {
  border-color: #cbd5e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.ConnectorDefinitionsPanel_cardBody__\\+wf2m {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ConnectorDefinitionsPanel_cardLine1__fJctY {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.ConnectorDefinitionsPanel_cardName__efO2o {
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
}

.ConnectorDefinitionsPanel_badgeTenant__60Rsv {
  font-size: 11px;
  font-weight: 600;
  color: #6b46c1;
  background: #faf5ff;
  border: 1px solid #e9d8fd;
  padding: 2px 8px;
  border-radius: 10px;
}

.ConnectorDefinitionsPanel_badgeProvider__WEduN {
  font-size: 11px;
  font-weight: 600;
  color: #4a5568;
  background: #edf2f7;
  border: 1px solid #e2e8f0;
  padding: 2px 8px;
  border-radius: 10px;
  text-transform: capitalize;
}

.ConnectorDefinitionsPanel_cardLine2__K7bR9 {
  font-size: 12px;
  color: #4a5568;
}

.ConnectorDefinitionsPanel_cardLine2__K7bR9 code {
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, monospace;
  background: #f7fafc;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
}

.ConnectorDefinitionsPanel_cardLine3__f1jBr {
  font-size: 12px;
  color: #a0aec0;
}

.ConnectorDefinitionsPanel_cardActions__bdpDZ {
  display: flex;
  align-items: center;
  gap: 6px;
}

.ConnectorDefinitionsPanel_iconBtn__GymYo,
.ConnectorDefinitionsPanel_deleteBtn__ql3g7 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  border-radius: 6px;
  cursor: pointer;
  color: #4a5568;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.ConnectorDefinitionsPanel_iconBtn__GymYo:hover {
  background: #edf2f7;
  color: #2d3748;
}

.ConnectorDefinitionsPanel_deleteBtn__ql3g7:hover {
  background: #fff5f5;
  color: #c53030;
  border-color: #feb2b2;
}

.ConnectorDefinitionsPanel_footnote__4ntEl {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 14px;
  font-size: 12px;
  color: #718096;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  line-height: 1.55;
}

.ConnectorDefinitionsPanel_footnote__4ntEl svg {
  flex-shrink: 0;
  margin-top: 2px;
  color: #a0aec0;
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/ConnectorDefinitionsPanel.module.css"],"names":[],"mappings":"AAAA;;;;uCAIuC;;AAEvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,mEAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sEAAsE;EACtE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* qchat_fe/src/Component/SideData/Overview/AiAgentWorkFlow/ConnectorDefinitionsPanel.module.css\n *\n * Styles for the connector definitions library panel. Mirrors the\n * visual language of OAuthConnections.module.css so the two tabs of\n * the Connectors page look coherent. */\n\n.container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.loadingBlock {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #718096;\n  font-size: 14px;\n  padding: 32px 0;\n  justify-content: center;\n}\n\n.spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n\n.headerRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1a202c;\n  margin: 0 0 6px 0;\n}\n\n.subtitle {\n  font-size: 13px;\n  color: #718096;\n  line-height: 1.55;\n  margin: 0;\n  max-width: 680px;\n}\n\n.createBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #ffffff;\n  background: #4299e1;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s;\n}\n\n.createBtn:hover {\n  background: #3182ce;\n}\n\n.emptyState {\n  padding: 48px 24px;\n  text-align: center;\n  border: 1px dashed #cbd5e0;\n  border-radius: 8px;\n  color: #718096;\n  font-size: 14px;\n  background: #f7fafc;\n}\n\n.emptyState p {\n  margin: 0;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 16px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.card:hover {\n  border-color: #cbd5e0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);\n}\n\n.cardBody {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.cardLine1 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.cardName {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.badgeTenant {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6b46c1;\n  background: #faf5ff;\n  border: 1px solid #e9d8fd;\n  padding: 2px 8px;\n  border-radius: 10px;\n}\n\n.badgeProvider {\n  font-size: 11px;\n  font-weight: 600;\n  color: #4a5568;\n  background: #edf2f7;\n  border: 1px solid #e2e8f0;\n  padding: 2px 8px;\n  border-radius: 10px;\n  text-transform: capitalize;\n}\n\n.cardLine2 {\n  font-size: 12px;\n  color: #4a5568;\n}\n\n.cardLine2 code {\n  font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, monospace;\n  background: #f7fafc;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 11px;\n}\n\n.cardLine3 {\n  font-size: 12px;\n  color: #a0aec0;\n}\n\n.cardActions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.iconBtn,\n.deleteBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #4a5568;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n\n.iconBtn:hover {\n  background: #edf2f7;\n  color: #2d3748;\n}\n\n.deleteBtn:hover {\n  background: #fff5f5;\n  color: #c53030;\n  border-color: #feb2b2;\n}\n\n.footnote {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 12px 14px;\n  font-size: 12px;\n  color: #718096;\n  background: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  line-height: 1.55;\n}\n\n.footnote svg {\n  flex-shrink: 0;\n  margin-top: 2px;\n  color: #a0aec0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ConnectorDefinitionsPanel_container__CQRO7`,
	"loadingBlock": `ConnectorDefinitionsPanel_loadingBlock__VoRZE`,
	"spin": `ConnectorDefinitionsPanel_spin__d7QQD`,
	"headerRow": `ConnectorDefinitionsPanel_headerRow__t7IiV`,
	"title": `ConnectorDefinitionsPanel_title__9dEev`,
	"subtitle": `ConnectorDefinitionsPanel_subtitle__DXjVC`,
	"createBtn": `ConnectorDefinitionsPanel_createBtn__00mTB`,
	"emptyState": `ConnectorDefinitionsPanel_emptyState__kNm0j`,
	"list": `ConnectorDefinitionsPanel_list__-4H7d`,
	"card": `ConnectorDefinitionsPanel_card__nWERK`,
	"cardBody": `ConnectorDefinitionsPanel_cardBody__+wf2m`,
	"cardLine1": `ConnectorDefinitionsPanel_cardLine1__fJctY`,
	"cardName": `ConnectorDefinitionsPanel_cardName__efO2o`,
	"badgeTenant": `ConnectorDefinitionsPanel_badgeTenant__60Rsv`,
	"badgeProvider": `ConnectorDefinitionsPanel_badgeProvider__WEduN`,
	"cardLine2": `ConnectorDefinitionsPanel_cardLine2__K7bR9`,
	"cardLine3": `ConnectorDefinitionsPanel_cardLine3__f1jBr`,
	"cardActions": `ConnectorDefinitionsPanel_cardActions__bdpDZ`,
	"iconBtn": `ConnectorDefinitionsPanel_iconBtn__GymYo`,
	"deleteBtn": `ConnectorDefinitionsPanel_deleteBtn__ql3g7`,
	"footnote": `ConnectorDefinitionsPanel_footnote__4ntEl`
};
export default ___CSS_LOADER_EXPORT___;
